import styles from './ProductSelection.module.scss'
import Headphones from "../../../../../../assets/images/product-image-headphones.png"
import { Button, Container } from 'reactstrap'
import DataTable from 'react-data-table-component'
import FilterInTable from '../../../../../Manage/FilterInTable'


const ProductSelection = ({ handleClick }) => {

    const data = [
        { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, price: 300, status: "Eligible" },
        { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, price: 300, status: "Eligible" },
        { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, price: 300, status: "Eligible" },
        { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, price: 300, status: "Eligible" },
        { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, price: 300, status: "Eligible" },
        { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, price: 300, status: "Eligible" },
        { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, price: 300, status: "Eligible" },
        { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, price: 300, status: "Eligible" },
    ]

    const columns = [
        {
            name: "Product Image",
            cell: (row) => <img src={row.productImage} alt="" width={45} height={47} />,
            styles: {
                display: "flex",
                justifyContent: "center",
            },
        },
        {
            name: "Product Name",
            selector: (row) => row.name,
        },
        {
            name: "Category",
            selector: (row) => row.category,
        },
        {
            name: "SKU",
            selector: (row) => row.sku,
        },
        {
            name: "Stock",
            selector: (row) => row.stock,
        },
        {
            name: "Price",
            selector: (row) => row.price,
        },
        {
            name: "Status",
            selector: (row) => row.status,
        },
    ]

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: "#f2f2f2",
                fontSize: "1rem",
                fontWeight: 600,
            },
        },
        cells: {
            style: {
                paddingBlock: "1rem",
            },
        },
    }


    return (
        <div>
            <div className={styles.addProductBtnContainer}>
                <Button type="button" color="primary" className={styles.productBtn} onClick={handleClick}>
                    Next Step
                </Button>
            </div>
            <Container fluid className={`g-0 ${styles["wrapper"]}`}>
                <div className={styles["heading"]}>Product Selection</div>
            </Container>
            <Container fluid className={`g-0 ${styles["table-wrapper"]}`}>
                <div className='mb-3'>
                    <FilterInTable componentName="Campaign Product Selection" />
                </div>
                <DataTable data={data} columns={columns} customStyles={customStyles} selectableRows />
            </Container>
        </div>
    )
}

export default ProductSelection
